import React from "react";
import { HiArrowLeft } from "@react-icons/all-files/hi/HiArrowLeft";

import { classNames } from "repoV2/utils/common/render/classNames";
import styles from "./ModalStyles.module.scss";

interface IMobileHeaderClasses {
    header: string;
    title: string;
    close: string;
    back: string;
}

interface IModalHeaderProps {
    children?: React.ReactNode;
    classes?: Partial<IMobileHeaderClasses>;
    onBackClick?: () => void;
    showCloseIcon?: boolean;
    showBackCta?: boolean;
    onClose?: () => void;
}

const ModalHeader = ({
    classes = {},
    onBackClick,
    children,
    showCloseIcon = true,
    showBackCta = true,
    onClose,
}: IModalHeaderProps) => {
    return (
        <div className={classNames(styles.header, classes.header)}>
            {showBackCta && (
                <HiArrowLeft
                    className={classNames(
                        styles.back,
                        classes.back,
                        onBackClick ? "" : "invisible"
                    )}
                    onClick={onBackClick}
                    title="Back"
                />
            )}

            <div className={classNames(styles.title, classes.title)}>
                {children}
            </div>

            <div
                className={classNames(
                    styles.close,
                    classes.close,
                    !showCloseIcon && "invisible"
                )}
                title="Close"
                onClick={onClose}
            >
                &times;
            </div>
        </div>
    );
};

ModalHeader.defaultProps = {
    children: undefined,
    classes: {},
    onBackClick: undefined,
    showCloseIcon: true,
    showBackCta: true,
    onClose: () => {},
};

export default ModalHeader;
